// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2gaR7","content":"RecentSearches_content__1scEs"};